<template>
	<v-col class="sponsorisasi">
		<div class="d-flex justify-space-between">
			<div class="font-size-14 font-weight-bold cl-agen-dark">Profil</div>
		</div>
		<div class="mt-2">
			<div class="d-flex flex-wrap" v-if="loading">
				<v-col cols="12" sm="4" md="3" xl="2" class="pl-0 pr-0 pr-sm-3">
					<v-card class="elevation-0 rounded-xl">
						<vcl :height='500'>
							<rect x="80" y="50" rx="140" ry="140" width="240" height="240" />
							<rect x="110" y="330" rx="2" ry="2" width="180" height="25" />
							<rect x="125" y="370" rx="2" ry="2" width="150" height="25" />
							<rect x="150" y="430" rx="2" ry="2" width="100" height="25" />
						</vcl>
					</v-card>
				</v-col>
				<v-col cols="12" sm="8" md="9" xl="6" class="pr-0 pl-0 pl-sm-3">
					<v-card class="elevation-0 rounded-xl">
						<vcl :height='280'>
							<rect x="20" y="20" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="20" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="65" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="65" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="110" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="110" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="155" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="155" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="200" rx="2" ry="2" width="170" height="12" />
							<rect x="210" y="200" rx="2" ry="2" width="170" height="12" />
							<rect x="20" y="245" rx="2" ry="2" width="360" height="12" />
						</vcl>
					</v-card>
				</v-col>
			</div>
			<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
				<div class="d-flex flex-wrap" v-if="!loading">
					<v-col cols="12" sm="4" md="3" xl="2" class="pl-0 pr-0 pr-sm-3">
						<v-card class="pa-5 elevation-0 rounded-xl">
							<!-- <div class="bg-card-profile">
								<v-img :src="require('/public/assets/background/bg-profile-picture.svg')"></v-img>
							</div> -->
							<v-row class="mt-3">
								<v-col cols="12">
									<v-row justify="center">
										<v-col cols="7" sm="9" class="px-0 py-5">
											<div class="text-center rounded white" >
												<v-img height="165" width="165" class="user-img mx-auto rounded-pill" :src="(myProfile.member_image_url) ? myProfile.member_image_url : 'assets/image/profile-pict.png'"></v-img>
													<v-file-input hide-input accept="image/png, image/jpeg, image/jpg" prepend-icon="mdi-camera" clearable hint="Ukuran maksimal file 3 MB" class="icon-upload-image" width="20" @change="handleFileUpload($event)"></v-file-input>
											</div>
										</v-col>
									</v-row>
									<div class="font-size-9 red--text text--lighten-2 text-center" v-if="error_img_msg">{{ error_img_msg }}</div>
									<div class="pt-5 text-center">
										<div class="font-size-14 cl-grey font-weight-600">{{ myProfile.member_name }}</div>
										<div class="font-size-11 primary--text font-weight-500">{{ myProfile.member_network_code }}</div>
									</div>

									<v-card outlined class="mt-4 py-1 rounded-xl" v-if="false">
										<div class="d-flex align-center justify-center text-center">
											<div class="my-2" v-if="false">
												<v-img width="48" style="height: auto;max-width: 100%;" class="mr-3" :src="getNetworkTypeBadge(myProfile.member_network_code)"></v-img>
											</div>
											<div class="font-size-10 font-size-xs-10 font-weight-600 d-flex flex-column" v-if="false">
												<div class="text-uppercase font-size-16 cl-agen-dark" >{{ myProfile.member_network_type }}</div>
											</div>
										</div>
									</v-card>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
					<v-col cols="12" sm="8" md="9" xl="6" class="pr-0 pl-0 pl-sm-3">
						<v-tabs grow background-color="teal lighten-5" class="no-slider bg-light-primary" v-if="false">
							<v-tab @click="switchProfile">Data Profil</v-tab>
						</v-tabs>
						<v-scroll-x-reverse-transition mode="in-out" :hide-on-leave="true">
							<template v-if="Object.values(myProfile).length > 0">
								<ProfilData :provincesData="provinces" :citiesData="cities" :subdistrictsData="subdistricts" :banks="banks" :data="myProfile"></ProfilData>
							</template>
						</v-scroll-x-reverse-transition>
					</v-col>
				</div>
			</v-scroll-x-reverse-transition>
		</div>
	</v-col>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import ProfilData from './components/ProfilData';

export default {
	components: {
		ProfilData
	},
	data() {
		return {
			loading: true,
			isActiveMember: false,
			error_img_msg : '',
			kemitraan: [
				{
					type: 'Sahabat',
					color: '#86D4FF',
					badges: '',
					bgs: 'assets/icon/bg-sahabat.png',
					cards: 'assets/icon/member-card-sahabat.png',
					classText: 'mitra-bronze'
				},
				{
					type: 'Duta',
					color: '#1CC5DC',
					badges: '',
					bgs: 'assets/icon/bg-duta.png',
					cards: 'assets/icon/member-card-duta.png',
					classText: 'mitra-silver'
				},
				{
					type: 'Juragan',
					color: '#96BAFF',
					badges: '',
					bgs: 'assets/icon/bg-juragan.png',
					cards: 'assets/icon/member-card-juragan.png',
					classText: 'mitra-gold'
				},
				{
					type: 'Sultan',
					color: '#3FBCC3',
					badges: '',
					bgs: 'assets/icon/bg-sultan.png',
					cards: 'assets/icon/member-card-sultan.png',
					classText: 'mitra-diamond'
				}
			],
		}
	},
	computed: {
		...mapState('autentikasi', ['userData']),
		...mapState('opsi', ['provinces', 'cities', 'subdistricts', 'banks']),
		...mapState('profil', ['myProfile']),
	},
	methods: {
		...mapActions('opsi', ['getProvince', 'getCity', 'getSubdistrict', 'getBank']),
		...mapActions('profil', ['getProfileMitra', 'changeImageMitra']),
		...mapMutations('profil', ['clearDataUser']),

		async getData() {
			this.loading = await true
			await this.getProvince()
			await this.getBank()
			await this.getProfileMitra().then(() => {
				if ( this.myProfile.member_province_id > 0 ) {
					this.getCity({province_id: this.myProfile.member_province_id})
					if ( this.myProfile.member_city_id > 0 ) {
						this.getSubdistrict({city_id: this.myProfile.member_city_id})
					}
				}
			})
			this.loading = await false
		},
		getNetworkTypeBadge(type) {
			if(type === 'repeat_order') {
				type = 'silver'
			}
			const netType = this.kemitraan.find(x => x.type === type)
			return netType.badges
		},
		getNetworkTypeColor(type) {
			const netType = this.kemitraan.find(x => x.type === type)
			return netType.color
		},
		handleFileUpload(event) {
			if ( event.size > 3145728 ) {
				this.error_img_msg = "Maksimal ukuran gambar 3 MB"
				setTimeout(()=> {
					this.error_img_msg = ""
				}, 5000)
			} else if ( event.type != 'image/jpeg' && event.type != 'image/jpg' && event.type != 'image/png' ) {
				this.error_img_msg = "File yang diizinkan jpg/jpeg/png"
				setTimeout(()=> {
					this.error_img_msg = ""
				}, 5000)
			} else {
				let formData = new FormData()
				formData.append('image', event)	

				this.changeImageMitra(formData).then(() => {
					this.getData()
					this.error_img_msg = ""
				})
			}
		},
		
	},
	created() {
		this.$store.dispatch('setPageTitle', `Profil`)
		this.getData()
	},
	beforeDestroy() {
		this.clearDataUser()
	}
};
</script>